import React, { memo, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {}

const RankingIcon: React.FC<IProps> = (props) => {
	return (
		<svg
			width="73"
			height="73"
			viewBox="0 0 73 73"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M26.3713 42.583H12.1667C8.82087 42.583 6.08337 45.3205 6.08337 48.6663V66.9163H26.3713V42.583Z"
				stroke="currentColor"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M40.5454 30.417H32.4242C29.0783 30.417 26.3408 33.1545 26.3408 36.5003V66.917H46.6287V36.5003C46.6287 33.1545 43.9217 30.417 40.5454 30.417Z"
				stroke="currentColor"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M60.8334 51.708H46.6288V66.9163H66.9167V57.7913C66.9167 54.4455 64.1792 51.708 60.8334 51.708Z"
				stroke="currentColor"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M38.0816 6.29657L39.6937 9.52073C39.9066 9.97698 40.4846 10.4028 40.9712 10.4636L43.8912 10.9503C45.7466 11.2545 46.2029 12.6232 44.8646 13.9311L42.5833 16.2123C42.1879 16.6078 41.975 17.3378 42.0966 17.8549L42.7354 20.6532C43.2525 22.8737 42.0662 23.7253 40.1195 22.5695L37.3821 20.9574C36.8954 20.6533 36.0741 20.6533 35.5875 20.9574L32.85 22.5695C30.9033 23.7253 29.717 22.8737 30.2341 20.6532L30.8729 17.8549C30.9946 17.3378 30.7816 16.5773 30.3862 16.2123L28.1354 13.9615C26.797 12.6232 27.2229 11.2848 29.1087 10.9807L32.0287 10.4941C32.5154 10.4028 33.0933 9.97701 33.3062 9.55117L34.9183 6.32692C35.8004 4.56275 37.1996 4.56282 38.0816 6.29657Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default memo(RankingIcon);
